module.exports = __webpack_public_path__ + "584ec42028f41c39d68dd859f1c196fb.svg";